export const redshiftConfigureDocLink =
  '/destinations/data-warehouses/amazon-redshift/#configure-amazon-redshift-as-a-destination';
export const postgresConfigureDocLink =
  '/destinations/databases/postgresql/#postgres-database-host';
export const hostUrlSection = 'destination-settings';
export const hostUrlLabel = 'host-url-field-help-text';
export const DEFAULT_MS_SQL_SCHEMA_NAME = 'dbo';
